// eslint-disable-next-line import/prefer-default-export
export function getButtonChecker(buttonsData, buttonsToRemove, buttonsToAdd) {
    return (buttonKey, callback) => {
        let buttonInfo = null;
        if (!(buttonKey in buttonsToRemove) && (buttonKey in buttonsData)) {
            buttonInfo = buttonsData[buttonKey];
        }
        else if (buttonKey in buttonsToAdd) {
            buttonInfo = buttonsToAdd[buttonKey];
        }
        if (buttonInfo) {
            callback(buttonInfo);
        }
    };
}
